export default "__VITE_ASSET__BOH2Xj_p__"